export default __webpack_public_path__ + "e12e4f630ddfe61fc37de43db7dfb245.svg";